import { render, staticRenderFns } from "./Allreferrals.vue?vue&type=template&id=50b00ad7&"
import script from "./Allreferrals.vue?vue&type=script&lang=js&"
export * from "./Allreferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports